import { Box, Divider, Typography } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import FinishModalContainer from '../../../../components/Modals/FinishModalContainerV2'
import FormModalContainer from '../../../../components/Modals/FormModalContainer'

import TitleWithIcon from '../../../../components/Cards/helpers/TitleWithIcon'
import { ReactComponent as NearMe } from '../../../../images/NearMe.svg'
import SideBarAvater from '../../../../components/SideBar/SideBarAvater'
import {
  isNotEmpty,
} from '../../../../utils/helpers'
import UseTranslation from '../../../../hooks/UseTranslation'
import RequestHistory from './RequestHistory'
import Actions from './Actions'
import GenericBtn from '../../../../components/Buttons/OfoqThemeBtn'
import successImage from '../../../../images/success.svg'
import { selectRequestInboxModalData } from '../../../../utils/confirmationDataContainer'
import { selectApproveFinishModalData, selectRejectFinishModalData } from '../../../../utils/finishDataContiner'
import {
  notificationsInboxActions,
  retrieveNotificationInboxDetails,
  retrieveNotificationInboxHistory,
} from '../../../../redux/features/notifications/notificationInbox/notificationInboxThunk'
import { selectNotificationInbox } from '../../../../redux/features/notifications/notificationInbox/notificationInboxSlice'
import DetailsRequestSkeleton from './detailsRequestSkeleton'
import appRoutes from '../../../../services/AppRoutes'
import DetailsRequest from './DetailsRequest'
import OverTimeDetailsRequest from './OverTimeDetailsRequest'
import ConfirmationModalContainerV2 from '../../../../components/Modals/ConfirmationModalContainerV2'

const NotificationDetailModel = ({
  modalStatus,
  setModalStatus,
  showActions,
  actionAfterSuccess,
}) => {
  const { t } = UseTranslation()
  const [showFinishModal, setShowFinishModal] = useState(false)
  const [showConfirmationModal, setShowConfirmationModal] = useState(false)
  const [comment, setComment] = useState('')
  const [selectedAction, setSelectedAction] = useState('approve')
  const { status, data } = modalStatus
  const notificationInboxStore = useSelector(selectNotificationInbox)
  const history = useHistory()
  const [modalData, setModalData] = useState(null)

  const dispatch = useDispatch()
  const handleNotificationRequestForm = () => {
    dispatch(
      notificationsInboxActions({
        action: selectedAction ? 'approve' : 'reject',
        queries: {
          id: data?.id,
          comment,
        },
      }),
    ).then((res) => {
      if (res?.meta?.requestStatus === 'fulfilled') {
        setShowFinishModal(true)
        cancelHandler()
      }
    })
  }
  useEffect(() => {
    if (status) {
      dispatch(retrieveNotificationInboxDetails({ queries: data?.request_uuid }))
      dispatch(retrieveNotificationInboxHistory({ queries: data?.request_uuid }))
    }
  }, [status])

  const cancelHandler = () => {
    setModalStatus(false)
  }
  const handleClick = () => {
    setShowConfirmationModal(true)
    const action = selectedAction
    const employeeName = data?.employee?.name
    const requestType = data?.source_type?.value
    const modalAction = selectRequestInboxModalData(action, employeeName, requestType, t)
    setModalData(modalAction)
  }

  const finishModalHandler = () => {
    setShowFinishModal(false)
    if (actionAfterSuccess) {
      actionAfterSuccess()
    }
  }
  const details = notificationInboxStore.detailsRequest
  return (
    <Box data-testid="details-modal">
      <FormModalContainer
        modalTitle={data?.source_type?.value}
        modalState={status}
        handleClose={cancelHandler}
        largeSize
      >
        <Box sx={styles.headerContainer}>
          <TitleWithIcon
            title={t?.['Request Details']}
            icon={<NearMe />}
            textVariant="heading4"
            customStyle={styles.titleWithIcon}
          />
          <Box sx={styles.employeeMainInfo}>
            <SideBarAvater name={data?.employee?.name} customStyle={styles.avatar} />
            <Box sx={styles.employeeInfo}>
              <Box sx={styles.employeeCodeTitle}>
                <Box sx={styles.xsTitle}>
                  <Typography variant="h5">
                    {isNotEmpty(data?.employee?.name)
                      ? data?.employee?.name?.trim()?.split(' ')?.slice(0, 2)?.join(' ')
                      : '-- -- --'}
                  </Typography>
                  <Typography variant="h6">
                    {`# ${isNotEmpty(data?.employee?.code) ? data?.employee?.code : '-- -- --'}`}
                  </Typography>
                </Box>
                <Typography variant="p">
                  {isNotEmpty(data?.employee?.job?.name) ? data?.employee?.job?.name : '-- -- --'}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
        <Divider sx={styles.headerDivider} />
        {notificationInboxStore?.loading?.fetch && <DetailsRequestSkeleton />}

        {!notificationInboxStore?.loading?.fetch &&
  (details?.type?.key === 'OVERTIME_REQUEST'
    ? <OverTimeDetailsRequest details={details} />
    : <DetailsRequest details={details} />
  )}

          <Divider sx={styles.divider} />
          <RequestHistory />

        {showActions && (
          <>
            <Divider sx={styles.divider} />
            <Actions
              comment={comment}
              setComment={setComment}
              selectedAction={selectedAction}
              setSelectedAction={setSelectedAction}
            />
          </>
        )}
        <Box sx={styles.buttonsContainer}>
          <GenericBtn
            name={showActions ? t?.cancel : t?.Close}
            onClick={cancelHandler}
            customStyle={styles.cancelBtn}
            cancelStyle={showActions}
          />
          {showActions && (
            <GenericBtn name={t?.Send} customStyle={styles.sendBtn} onClick={handleClick} />
          )}
        </Box>
      </FormModalContainer>
      <ConfirmationModalContainerV2
        modalState={showConfirmationModal}
        setModalState={setShowConfirmationModal}
        modalData={modalData}
        functionToDispatch={handleNotificationRequestForm}
      />
      <FinishModalContainer
        modalState={showFinishModal}
        actionAfterSuccess={finishModalHandler}
        modalData={selectedAction === 'approve' ? selectApproveFinishModalData : selectRejectFinishModalData}
        modalIcon={successImage}
      >
        <Box sx={styles.modalMsg}>
          <Typography sx={styles.modalMsgText} variant="heading4">
            {t?.['You can monitor the status of this action in the']}
            <Typography component="span" sx={styles.modalMsgSpan} onClick={() => history.push(appRoutes.ActionHistory)}>
              {t?.['Action History Screen']}
            </Typography>
          </Typography>
        </Box>
      </FinishModalContainer>
    </Box>
  )
}

const styles = {
  headerContainer: {
    display: 'flex',
    flexDirection: { xs: 'column-reverse', sm: 'column' },
  },
  titleWithIcon: {
    margin: { xs: '0px', sm: '20px 0px 0px 20px' },
    '& svg': {
      width: { xs: '15px', sm: '25px' },
      height: { xs: '15px', sm: '25px' },
    },
    '& span': {
      marginLeft: '8px',
      marginBottom: '4px',
      fontFamily: 'Avenir',
    },
  },
  employeeMainInfo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    margin: '10px 0px 10px 0px',
    borderBottom: (theme) => ({
      xs: `1px solid ${theme.palette.grey[200]}`,
      sm: 'none',
    }),
  },
  divider: {
    width: { xs: '100%', sm: '800px !important' },
    margin: 'auto',
    color: 'grey.200',
    marginBottom: '10px',
    paddingTop: '10px',
  },
  headerDivider: {
    width: { xs: '100%', sm: '800px' },
    margin: 'auto',
    color: 'grey.200',
    marginBottom: '10px',
    paddingTop: '10px',
    display: { xs: 'none', sm: 'block' },
  },
  avatar: {
    width: { xs: '40px', sm: '50px' },
    height: { xs: '40px', sm: '50px' },
    fontSize: { xs: '14px', md: '20px' },
    fontWeight: 700,
    fontFamily: 'Avenir',
    ml: { xs: '0px', sm: 'unset' },
    marginRight: '14px',
    borderRadius: { xs: '12px', md: '50% !important' },
  },
  employeeCodeTitle: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    '& span': {
      marginTop: { sm: '3px' },
    },
  },
  employeeInfo: {
    marginLeft: '5px',
    '& h5': {
      width: 'max-content',
      height: '31px',
      fontFamily: 'Avenir 85 Heavy',
      fontWeight: 500,
      fontSize: { xs: '14px', sm: '20px' },
      lineHeight: { xs: '20.15px', sm: '31px' },
    },
    '& h6': {
      maxWidth: 'fit-content',
      height: '20px',
      fontFamily: 'Avenir 85 Heavy',
      fontSize: { xs: '12px', sm: '12px' },
      lineHeight: '20px',
      mr: '5px',
    },
    '& span': {
      maxWidth: '100%',
      height: '21px',
      fontFamily: 'Avenir !important',
      fontWeight: 350,
      fontSize: { xs: '12px', sm: '14px' },
      lineHeight: '21px',
      textAlign: 'center',
      color: 'grey.500',
      marginTop: { xs: '-10px', sm: 'unset' },
    },

  },
  claimButton: {
    minWidth: '110px',
    maxWidth: 'fit-content',
    padding: '0 15px',
  },
  buttonsContainer: {
    width: '100% !important',
    display: 'flex',
    justifyContent: 'flex-end',
    borderTop: (theme) => `1px solid ${theme.palette.grey[200]}`,
    padding: { xs: '0 16px', sm: '10px 16px 0 16px' },
    margin: { xs: '0px -16px 0px -16px', sm: '0 -16px' },
    marginTop: 0,
    gap: '10px',
  },
  cancelBtn: {
    display: { xs: 'none', sm: 'initial' },
    textAlign: 'center',
    width: '96px',
    height: '40px',
  },
  sendBtn: {
    mt: { xs: '5px', sm: '0px' },
    marginInline: { xs: '0px !important', sm: '10px' },
    maxWidth: { xs: '100%', sm: '96px' },
  },
  xsTitle: {
    display: 'flex',
    gap: { xs: '6px', sm: '0' },
    flexDirection: { xs: 'row', sm: 'column' },
  },
  modalMsg: {
    display: 'flex', textAlign: 'center', justifyContent: 'center', mt: '-20px',
  },
  modalMsgText: {
    color: 'grey.500',
    paddingRight: '5px',
  },
  modalMsgSpan: {
    color: 'primary.main',
    cursor: 'pointer',
    marginLeft: '5px',
  },
}
export default NotificationDetailModel
